import React from 'react';
import styled from 'styled-components';
import { Button as MuiButton } from '@material-ui/core';
import { ArrowDropDown, FilterList } from '@material-ui/icons';

export const Button = styled(MuiButton).attrs({
  size: 'small',
  startIcon: <FilterList />,
  endIcon: <ArrowDropDown />,
})`
  font-family: Poppins;
  font-weight: 600;
  font-size: 0.8125rem;
  text-transform: uppercase;
  padding: 4px 5px;
  color: rgba(0, 0, 0, 0.54);
  letter-spacing: 0.02857em;
  min-width: 0;

  & .MuiButton-startIcon,
  & .MuiButton-endIcon {
    margin-left: 4px;
    margin-right: 4px;
  }

  & .MuiButton-startIcon svg {
    font-size: 1.4rem;
  }
`;
